import { Phone, Mail, MapPin, Clock } from "lucide-react";
import LeadForm from "../components/LeadForm";
import { FadeIn, Reveal } from "../components/Motion";
import Seo from "../components/Seo";
import useContactInfo from "../lib/useContact";
import { track } from "../lib/track";

export default function Contact() {
  const BUSINESS = useContactInfo();
  return (
    <div data-testid="contact-page" className="pt-28">
      <Seo
        title="Free Deck Estimate | Zarco's Decks — Rome, Cartersville & Metro Atlanta"
        description="Request your free on-site deck estimate from Zarco's Decks & Outdoor Living. Call or text (678) 356-7281. Serving Rome, Cartersville, and North Georgia."
      />
      <section className="px-6 md:px-12 lg:px-20 py-16 md:py-24">
        <div className="grid lg:grid-cols-12 gap-12">
          <FadeIn className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.2em] text-[#99582A] font-semibold">
              Free Estimate
            </p>
            <h1 className="font-display text-5xl md:text-6xl tracking-tighter font-medium mt-5 leading-[1.02]">
              Let's design<br />your outdoor<br />space.
            </h1>
            <p className="mt-8 text-[#4A4A4A] text-base md:text-lg leading-relaxed">
              Tell us about your project. We'll review your details, reach out
              within 24 hours, and schedule a free on-site walk-through.
            </p>

            <div className="mt-12 space-y-6 border-t border-[#E5E5E5] pt-10">
              <ContactRow icon={Phone} label="Call or Text">
                <a
                  href={BUSINESS.phoneMainHref}
                  data-testid="contact-phone-main"
                  onClick={() => track("click_to_call", { location: "contact_page" })}
                  className="hover:text-[#99582A] transition-colors"
                >
                  {BUSINESS.phoneMain}
                </a>
              </ContactRow>
              <ContactRow icon={Mail} label="Email">
                <a
                  href={BUSINESS.emailHref}
                  data-testid="contact-email"
                  className="hover:text-[#99582A] transition-colors whitespace-nowrap"
                >
                  {BUSINESS.email}
                </a>
              </ContactRow>
              <ContactRow icon={MapPin} label="Service Area">
                <span data-testid="contact-service-area">{BUSINESS.serviceArea}</span>
              </ContactRow>
              <ContactRow icon={Clock} label="Hours">
                <span>{BUSINESS.hours}</span>
              </ContactRow>
            </div>
          </FadeIn>

          <Reveal delay={0.12} className="lg:col-span-7">
            <LeadForm />
          </Reveal>
        </div>
      </section>
    </div>
  );
}

function ContactRow({ icon: Icon, label, children }) {
  return (
    <div className="flex items-start gap-5">
      <div className="w-10 h-10 bg-[#FAF8F4] flex items-center justify-center shrink-0 mt-1">
        <Icon size={18} strokeWidth={1.5} className="text-[#99582A]" />
      </div>
      <div>
        <p className="text-[11px] uppercase tracking-[0.2em] text-[#666] font-semibold">
          {label}
        </p>
        <p className="mt-1 text-[#111]">{children}</p>
      </div>
    </div>
  );
}
